import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../hooks/useLogin.js';
import Button from '../components/Button.jsx';
import FormField from '../components/FormField.jsx';

export default function LoginPage({ onPreauthToken }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const login = useLogin();

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const data = await login.mutateAsync({ email, password });
      const token = data?.preauth_token;
      if (!token) {
        // Should not happen but handle gracefully
        navigate('/');
        return;
      }
      onPreauthToken(token, data);
      // Backend returns totp_enabled on login response or we infer from flow
      if (data?.totp_enabled === false) {
        navigate('/2fa/setup', { state: { preauth_token: token } });
      } else {
        navigate('/2fa/verify', { state: { preauth_token: token } });
      }
    } catch (err) {
      // error shown via login.error
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <p className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-1">Treasury</p>
          <h1 className="text-2xl font-bold text-slate-900">Legendary Parts</h1>
          <p className="text-sm text-slate-500 mt-1">Connectez-vous à votre espace</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 space-y-4"
          aria-label="Formulaire de connexion"
        >
          {login.error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" role="alert">
              {login.error.message ?? 'Identifiants incorrects'}
            </div>
          )}

          <FormField label="Adresse email" htmlFor="email" required>
            <input
              id="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-500"
              placeholder="victor@legendary-parts.com"
              required
            />
          </FormField>

          <FormField label="Mot de passe" htmlFor="password" required>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-500"
              required
            />
          </FormField>

          <Button
            type="submit"
            className="w-full mt-2"
            loading={login.isPending}
          >
            Continuer
          </Button>
        </form>
      </div>
    </div>
  );
}
